import AgentActivity from 'models/agent_activity';
import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';
import { SidePanelType } from 'models/side_panel';

export default class CloseCommentPanel {
  constructor(context) {
    this.context = context;
  }

  run() {
    const commentPanel = this.context.stores.commentPanel.get();
    commentPanel.clearItemId();
    this.context.stores.commentPanel.set(commentPanel);

    const sidePanel = this.context.stores.sidePanel.get();
    const wasOpen = sidePanel.isShowing(SidePanelType.TASK);

    if (!wasOpen) {
      return;
    }

    sidePanel.close();
    this.context.stores.sidePanel.set(sidePanel);

    this.context.executeAction(SetAndLogActivity, {
      type: AgentActivity.Type.TASK_COMMENT_PANEL_CLOSE,
    });
  }
}
